import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { pricingElevation } from '~app/styles/theme';
import { LG_MEDIA_QUERY, MD_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  GROW_2529_Switch: {
    fontSize: type.fontSize.body,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing[1],
    margin: [0, 'auto'],
    lineHeight: 1.5,
    color: pricingPalette.colors.slate,
    backgroundColor: pricingPalette.colors.pebble,
    borderRadius: 50,
    width: '90%',
    maxWidth: 280,
    position: 'absolute',
    top: spacing[4],
    left: 0,
    right: 0,

    [LG_MEDIA_QUERY]: {
      marginBottom: 0,
    },

    '& input': {
      opacity: 0,
      width: 0,
      height: 0,
      position: 'absolute',
    },
  },
  Values: {
    width: '100%',
    minHeight: 36,
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    position: 'relative',
    cursor: 'pointer',

    [MD_MEDIA_QUERY]: {
      fontSize: '.75em',
    },

    [LG_MEDIA_QUERY]: {
      fontSize: '1em',
    },

    '& span': {
      textAlign: 'center',
      zIndex: pricingElevation.plusOne,
      transition: 'all ease-out .3s',
      fontWeight: type.fontWeight.medium,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: [0, '7%'],
      borderRadius: 50,
      '&:first-child': {
        backgroundColor: pricingPalette.colors.white,
      },
    },
  },

  Checked: {
    '& span:first-child': {
      backgroundColor: 'transparent',
    },
    '& span:last-child': {
      backgroundColor: pricingPalette.colors.white,
    },
  },
}));
